/**
 * Адаптер для преобразования времени "из" и "в" формат для API.
 * @type {{toHoursMinutes(*): string}}
 */
const ApiTimeAdapter = {
  toHoursMinutes(time) {
    if (null === time) {
      return null;
    }

    return time.split(':').slice(0, 2).join(':');
  },
};

export {ApiTimeAdapter};